import {
  ApplicationStatus,
  HomeyStatus,
  NycProfileStatus,
  PaymentStatus,
  SubscriptionStatus,
} from '../api-client';

export type Severity = 'success' | 'secondary' | 'info' | 'warn' | 'danger' | 'contrast' | undefined;

/**
 * `lastSyncStatus`, `loginStatus` and the household NYC `syncStatus` are plain strings on the
 * API contract rather than enumerations, so these take `string` and fall through to a default.
 */
export function nycProfileStatusToTag(status: NycProfileStatus): Severity {
  switch (status) {
    case 'waiting-on-email1-verification':
    case 'waiting-on-email2-verification':
      return 'danger';
    case 'complete':
      return 'success';
    case 'profile-incomplete':
      return 'success';
    case 'not-created':
      return 'warn';
  }
}

export function lastSyncStatusToTag(status: string): Severity {
  switch (status) {
    case 'sync-complete':
      return 'success';
    case 'sync-failed':
      return 'danger';
    case 'not-synced':
    default:
      return 'warn';
  }
}

export function loginStatusToTag(status: string): Severity {
  switch (status) {
    case 'login-correct':
      return 'success';
    case 'login-failed':
      return 'danger';
    default:
      return 'warn';
  }
}

export function syncStatusToTag(status: string): Severity {
  switch (status) {
    case 'synced':
      return 'success';
    case 'sync-failed':
      return 'danger';
    case 'not-synced':
    default:
      return 'warn';
  }
}

export function homeyStatusToTag(status: HomeyStatus): Severity {
  switch (status) {
    case 'active':
      return 'success';
    case 'mandatory-flow':
      return 'warn';
  }
}

export function paymentStatusToTag(status: PaymentStatus): Severity {
  switch (status) {
    case 'paid':
      return 'success';
    case 'not-paid':
      return 'danger';
  }
}

export function subscriptionStatusToTag(status: SubscriptionStatus): Severity {
  switch (status) {
    case 'active':
      return 'success';
    case 'trialing':
      return 'info';
    case 'payment-pending':
      return 'warn';
    case 'canceled':
    case 'past_due':
    case 'incomplete':
    case 'incomplete_expired':
    case 'paused':
    case 'unpaid':
      return 'danger';
  }
}

export function applicationStatusToTag(status: ApplicationStatus): Severity {
  switch (status) {
    case 'not-selected':
    case 'selected':
    case 'applied':
    case 'pending-selection':
      return 'success';
    case 'failed':
      return 'danger';
    case 'not-synced':
      return 'warn';
  }
}

/**
 * Login- and sync-failure counters arrive as strings; any non-zero count is a problem.
 */
export function failureCountToTag(value: string): Severity {
  return Number(value) > 0 ? 'danger' : 'success';
}
